import { apiCall } from '@shared/entity';
import { axiosInstance } from '@libs/axios/axios';
import { MonthSchedule, WorkScheduleMonth } from '../../visits/schedule/entity';

export const getWorkScheduleMonth = async (
  year: number,
  month: number,
): Promise<WorkScheduleMonth> =>
  apiCall(
    async () => await axiosInstance.get(`api/work-schedule/${year}/${month}`),
    'api.workSchedule.notFound',
  );

export const updateWorkScheduleMonth = async (
  year: number,
  month: number,
  schedule: MonthSchedule,
): Promise<WorkScheduleMonth> =>
  apiCall(
    async () =>
      await axiosInstance.put(`api/work-schedule/${year}/${month}`, {
        schedule,
      }),
    'api.workSchedule.updateError',
  );

export const copyFromPreviousMonth = async (
  year: number,
  month: number,
): Promise<WorkScheduleMonth> =>
  apiCall(
    async () => await axiosInstance.post(`api/work-schedule/${year}/${month}/copy-from-previous`),
    'api.workSchedule.copyError',
  );
